module.exports = __webpack_public_path__ + "img/home-about-new.832e34c1.jpg";